module.exports = __webpack_public_path__ + "img/blue-uv-capture-white.fc7a745b.svg";